import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class VfsPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  itemsPerPageLabel;
  nextPageLabel;
  previousPageLabel;
  firstPageLabel;
  lastPageLabel;
  subscription: Subscription;

  constructor(protected translateService: TranslateService) {
    super();
    this.getTranslations();
  }

  getTranslations(): void {
    this.subscription = this.translateService
      .stream([
        'core.paginator.itemsPerPage',
        'core.paginator.nextPage',
        'core.paginator.previousPage',
        'core.paginator.firstPage',
        'core.paginator.lastPage'
      ])
      .pipe(
        tap(result => {
          this.itemsPerPageLabel = result['core.paginator.itemsPerPage'];
          this.nextPageLabel = result['core.paginator.nextPage'];
          this.previousPageLabel = result['core.paginator.previousPage'];
          this.firstPageLabel = result['core.paginator.firstPage'];
          this.lastPageLabel = result['core.paginator.lastPage'];
        })
      )
      .subscribe();
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.translateService.instant('core.paginator.of')} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} ${this.translateService.instant('core.paginator.of')} ${length}`;
  };

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
